import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('icon-demo')

export default function IconDemo({ children, title, dark }) {
  return (
    <div {...bem('', { dark })}>
      <div {...bem('content')}>
         {children}
       </div>
       {title &&<span {...bem('title')}>{title}</span>}
    </div>
  )
}

IconDemo.propTypes = {
  children: T.any.isRequired,
  title: T.string,
  dark: T.bool,
}
